import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ResourceModel } from '../../../core/models/resources/resource.model';

@Pipe({
    name: 'filterOnSearch',
    standalone: false
})
@Injectable({ providedIn: 'root' })
export class FilterOnSearchPipe implements PipeTransform {
    transform<T extends ResourceModel>(list: T[] | null | undefined, searchTerm: string): T[] | null | undefined {
        if (!searchTerm) {
            return list;
        }

        function matches(el: string) {
            return el && el.toLowerCase().includes(searchTerm.toLowerCase());
        }

        function isIncludedInKeyValue(keyValue: { [key: string]: string }) {
            let includedInLabels = false;
            for (let [key, value] of Object.entries(keyValue || {})) {
                if (matches(key) || matches(value)) {
                    includedInLabels = true;
                    break;
                }
            }
            return includedInLabels;
        }

        function itemMatches(item: any) {
            if (!item) return false;

            let isInLabels = isIncludedInKeyValue(item.labels);
            let isInAnnotations = isIncludedInKeyValue(item.annotations);

            return (
                matches(item.description) ||
                matches(item.displayName) ||
                matches(item.name) ||
                matches(item.type) ||
                isInLabels ||
                isInAnnotations
            );
        }

        return list.map(item => {
            const newItem = { ...item };
            const itemMatchesSearch = itemMatches(item);

            if (Array.isArray(item.children) && item.children.length > 0) {
                newItem.children = item.children.filter(childItem => itemMatches(childItem));
                return (itemMatchesSearch || newItem.children.length > 0) ? newItem : null;
            }

            return itemMatchesSearch ? newItem : null;
        }).filter(item => item !== null) as T[];
    }
}
